
class WebSocketService {
    private ws: WebSocket | null = null;
    private eventCallbacks = new Map<string, Function[]>();


    connect(url: string) {
        this.ws = new WebSocket(url);

        this.ws.onopen = () => {
            console.log("WebSocket Connected");
        };

        this.ws.onmessage = (event) => {
            const message = JSON.parse(event.data);
            this.handleMessage(message);
        };

        this.ws.onclose = () => {
            console.log("WebSocket Disconnected");
            // Optionally, try reconnecting or handle disconnection appropriately
        };

        this.ws.onerror = (error) => {
            console.error("WebSocket Error: ", error);
        };
    }

    private handleMessage(message: any) {
        // Handle incoming message
        console.log("Received message: ", message);
        if (message.event && this.eventCallbacks.has(message.event)) {
            this.eventCallbacks.get(message.event)?.forEach((callback) => {
                callback(message.data);
            });
        }
    }


    close() {
        if (this.ws) {
            this.ws.close();
        }
    }


    sendMessage(message: any) {
        if (this.ws) {
            this.ws.send(JSON.stringify(message));
        }
    }

    onMessage(event: string, callback: Function) {
        if (!this.eventCallbacks.has(event)) {
            this.eventCallbacks.set(event, []);
        }
        this.eventCallbacks.get(event)?.push(callback);
    }

    offMessage(event: string, callback: Function) {
        if (this.eventCallbacks.has(event)) {
            const filteredCallbacks = this.eventCallbacks.get(event)?.filter((cb) => cb !== callback);
            this.eventCallbacks.set(event, filteredCallbacks || []);
        }
    }

}

// Export a singleton instance of the WebSocketService
const webSocketService = new WebSocketService();
export default webSocketService;
